import { render, staticRenderFns } from "./treatments.vue?vue&type=template&id=70b86afd&scoped=true"
import script from "./treatments.vue?vue&type=script&lang=js"
export * from "./treatments.vue?vue&type=script&lang=js"
import style0 from "./treatments.vue?vue&type=style&index=0&id=70b86afd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b86afd",
  null
  
)

export default component.exports